const login = {
  en: {
    translation: {
      login: "Login",
      toc1: "Clicking on 'log in', you agree to our ",
      toc2: "Terms and Conditions",
      toc3: " and confirm to have read our ",
      toc4: "Privacy Policy",
      toc5: " and ",
      toc6: "Cookie Policy",
      toc7: ". You also state you are sixteen years old.",
      log: "Login",
      no_account_yet: "No business account yet?",
      create_it: "Create it now!",
      forgot_password: "Did you forget your password?",
      error_login: "Error",
      error_login_text: "Please check data and try again"
    }
  },
  it: {
    translation: {
      login: "Login",
      toc1: "Cliccando su 'accedi', accetti i nostri ",
      toc2: "Termini e Condizioni",
      toc3: " e confermi di aver letto le nostre ",
      toc4: "Privacy Policy",
      toc5: " e ",
      toc6: "Cookie Policy",
      toc7: ". Dichiari altresì di aver compiuto sedici anni.",
      log: "Accedi",
      no_account_yet: "Non hai ancora un account business?",
      create_it: "Crealo ora!",
      forgot_password: "Hai dimenticato la tua password?",
      error_login: "Errore",
      error_login_text: "Per favore controlla i dati immessi e riprova"
    }
  }
};

export default login;
